<template>
  <div class="container lnb d_container">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          공지사항
          <el-button class="title_btn" @click="moveCreate()" type="primary">등록</el-button>
        </div>

        <div class="list-content">
          <board-list-component :boardType="'notice'"></board-list-component>
        </div>
      </div>
      <div class="text_center"> </div>
    </div>
  </div>
</template>

<script>
import BoardListComponent from "@/components/board/BoardListComponent";
import EventBus from "@/utils/event-bus";

export default {
  name: "Notice",
  mixins: [],
  components: {BoardListComponent},
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    moveCreate(){
      this.$router.replace(this.$route.path);
      this.$router.push(`/notice/create`);
    },
  },
  watch: {

  },
}
</script>

<style lang="scss">
</style>